module.exports = __webpack_public_path__ + "img/3-裂变拓客-02.79d89bbd.png";